import handleSendMessage from "./handleSendMessage";

export const handleCompleteProject = async (setIsCompleteProjectModalOpen, socket, selectedChatSession, userInfo) =>{
    
    try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/chat/updateChatSessionStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-SECRET': process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ chatSessionId: selectedChatSession._id, status: 'completed' }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response from backend:", errorText);
      throw new Error('Failed to update chatSession status');
    }

    const data = await response.json();
    console.log('ChatSession status updated successfully:', data);
    setIsCompleteProjectModalOpen(false); 
    handleSendMessage(socket, {sessionId: selectedChatSession._id, fromUserId: userInfo._id, fromRole: 'system', content: `Project marked as complete by ${selectedChatSession.clientName.split(' ')[0]}.\n\nPayout has been initiated and may take up to 5 business days to appear in your account, depending on your bank.\n\nThank you for your work, ${selectedChatSession.videographerName.split(' ')[0]}!`})
    return data;
  } catch (error) {
    console.error('Error updated chatSession statys:', error);
    throw error;
  }
}